import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 6,
        customerSlugId: 'hidden',
        nextProcessingStartDate: subDays(new Date(), 0).toISOString(),
        creationDate: subDays(new Date(), 5676).toISOString(),
        statusProcessing: 'FINISHED',
        isProcessingSync: true,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 0).toISOString(),
        billingContact: 'v.noha@projectli.com',
        timezone: 'Atlantic/Azores',
        startWorkingHour: '09:00:00',
        endWorkingHour: '18:00:00',
        useIdsAsTitles: false,
        officeIpAddresses: ['127.0.0.1', '192.168.1.1', '10.0.0.1']
    }
];
